import { render, staticRenderFns } from "./public-quiz-question-answer.html?vue&type=template&id=dd8e79e2&scoped=true&"
import script from "./public-quiz-question-answer.js?vue&type=script&lang=js&"
export * from "./public-quiz-question-answer.js?vue&type=script&lang=js&"
import style0 from "./public-quiz-question-answer.scss?vue&type=style&index=0&id=dd8e79e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8e79e2",
  null
  
)

export default component.exports